import { createSchemaPlugin } from '../../factories/createSchemaPlugin'
import { SchemaStringNode } from './TypedNode'
import { SchemaStringModel } from './ViewModel'

export const SchemaStringPlugin = createSchemaPlugin(
  'Schema.String',
  SchemaStringModel,
  SchemaStringNode
)
